import './Router.scss';

export { default } from './Router';
